import DpFormMixin from 'src/core/components/DpForm/DpFormMixin.js'
import DpForm from 'src/core/components/DpForm/DpForm2.vue'
import VerificacaoModel from 'src/model/veiculo/VerificacaoModel.js'
import GrupoVerificacaoModel from 'src/model/veiculo/GrupoVerificacaoModel.js'
import NotificacaoMixin from 'src/core/mixin/NotificacaoMixin'
import Upload from 'src/components/Upload.vue'

export default {
  name: 'VerificacaoForm',
  components: { DpForm, Upload },
  mixins: [DpFormMixin, NotificacaoMixin],
  data () {
    return {
      grupos: [],
      modelPadrao: new VerificacaoModel(),
      modelGrupoVerificacao: new GrupoVerificacaoModel()
    }
  },
  mounted () {
    this.modelGrupoVerificacao.getListagem().then((response) => {
      this.grupos = response.dados ?? []
    }).catch((error) => {
      this.notificacao('erro', error.msg)
    })
  },
  methods: {
    setarImagem (e) {
      this.modelPadrao.form.foto = e.arquivo
      this.modelPadrao.form.foto_url_completa = e.arquivo.arquivo_url_completa
    }
  }
}
